export default "__VITE_ASSET__Z0Rlr5q$__"